import React from 'react'

export default props => (
  <section className='mw-page center st-mv5'>
    {props.children}
  </section>
)
